import Vue from "vue";
var GLOBAL_VUE = new Vue();
export default GLOBAL_VUE;
